(() => {
  if (window.cbAcousticHelpReady) return;
  window.cbAcousticHelpReady = true;
  const formatter = (dialog) => new Intl.NumberFormat(dialog.lang || document.documentElement.lang, {
    minimumFractionDigits: 2, maximumFractionDigits: 2
  });
  document.querySelectorAll('.cb-acoustic-dialog').forEach(dialog => {
    dialog.querySelectorAll('[data-cb-ac-fixed]').forEach(cell => {
      cell.textContent = formatter(dialog).format(Number(cell.dataset.cbAcFixed));
    });
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cb-ac-mode]');
    if (!button) return;
    const dialog = button.closest('.cb-acoustic-dialog');
    if (!dialog) return;
    const percent = button.dataset.cbAcMode === 'percent';
    dialog.querySelectorAll('[data-cb-ac-mode]').forEach(control => {
      control.setAttribute('aria-pressed', String(control === button));
    });
    dialog.querySelectorAll('[data-cb-ac-value]').forEach(label => {
      const value = Number(label.dataset.cbAcValue);
      label.textContent = percent ? Math.round(value * 100) + ' %' : formatter(dialog).format(value);
    });
  });
})();
